import { render, staticRenderFns } from "./consolidation-info.vue?vue&type=template&id=5dcec0b5&scoped=true"
import script from "./consolidation-info.vue?vue&type=script&lang=js"
export * from "./consolidation-info.vue?vue&type=script&lang=js"
import style0 from "./consolidation-info.vue?vue&type=style&index=0&id=5dcec0b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcec0b5",
  null
  
)

export default component.exports